import * as React from 'react';
import i18n from 'src/translation/i18n';
import CustomSelect from 'react-select';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import env from 'src/shared/env';
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles
} from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import { commentsRegEx } from 'src/utils/RegexUtils';
import ImageUpload from './ImageUpload/ImageUpload';

class DamagePartInfo extends React.Component<IDamagePartInfoProps, any> {
  public render() {
    const theme = createMuiTheme({
      overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: '15px',
            color: 'black',
            backgroundColor: 'white'
          }
        }
      }
    });
    return (
      <>
        <h4>{i18n.t('partClaim.partinfo')}</h4>
        <div>
          {this.props.DamagePartInfo.map((part: any, i: any) => (
            <div className={`d-flex`}>
              <div className={`brand-info row form-row mb-0  `} key={i}>
                <div className="form-group col-sm-12  col-md-4 col-lg-3 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="Dpartnumber"
                  >
                    {i18n.t('partClaim.partNumber')}:
                    <span className="required">*</span>
                  </label>
                  <input
                    className={`form-control ${
                      this.props.DamagePartErrorlist[i] &&
                      this.props.DamagePartErrorlist[i].DamagepartNumberError
                        ? 'is-invalid'
                        : this.props.DamageErrormsgshow &&
                          part.DpartNumber === ''
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="part.DpartNumber"
                    type="text"
                    value={part.DpartNumber}
                    onChange={e => this.props.handleDamagePartNumber(e, i)}
                  />
                </div>

                <div className="form-group col-sm-12 col-md-4 col-lg-3 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="orginvoiceNumber"
                  >
                    {i18n.t('partClaim.orginvoiceNumber')}:
                    <span className="required">*</span>
                  </label>
                  <div
                    className={`form-control select-dropdown ${
                      this.props.DamagePartErrorlist[i] &&
                      this.props.DamagePartErrorlist[i]
                        ?.DamageInvoiceNumberError
                        ? 'is-invalid'
                        : this.props.DamageErrormsgshow &&
                          (part.DinvoiceNumber === 0 ||
                            part.DinvoiceNumber.toString() === '')
                        ? 'form-control-error-border'
                        : ''
                    }`}
                  >
                    <CustomSelect
                      options={part.DpartInvoiceList}
                      className="custom-select"
                      onChange={(option: any) => {
                        this.props.handleDamageinvoice(option, i);
                      }}
                      value={part.DInvoiceOption}
                      placeholder="Select Invoice"
                    />
                  </div>

                  <span className="rp-warranty-input-error-internal">
                    {this.props.DamagePartErrorlist[i] &&
                    this.props.DamagePartErrorlist[i]?.DamageInvoiceNumberError
                      ? `${i18n.t('partClaim.Invoiceerrormsg')}`
                      : ''}
                  </span>
                </div>

                <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="quantity"
                  >
                    {i18n.t('partClaim.quantity')}:
                    <span className="required">*</span>
                  </label>
                  <input
                    className={`form-control ${
                      this.props.DamagePartErrorlist[i] &&
                      this.props.DamagePartErrorlist[i]?.DamagequantityError
                        ? 'is-invalid'
                        : (this.props.DamageErrormsgshow &&
                            part.Dquantity === 0) ||
                          part.Dquantityshow
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="part.quantity"
                    type="number"
                    pattern="[1-9]*"
                    value={
                      part.Dquantity === 0 ||
                      part.Dquantity < 0 ||
                      Number(part.Dquantity) === 0
                        ? part.Dquantityshow
                        : part.Dquantity
                    }
                    onChange={e => this.props.handleDamagequantity(e, i)}
                    readOnly={
                      part.DinvoiceNumber === 0 ||
                      part.Dquantityshow ||
                      part.Dquantity.toString() === '-'
                        ? true
                        : false
                    }
                    onKeyDown={e =>
                      (e.keyCode === 69 ||
                        e.keyCode === 190 ||
                        e.keyCode === 173 ||
                        e.keyCode === 189 ||
                        e.keyCode === 109 ||
                        e.keyCode === 110 ||
                        e.key === '+') &&
                      e.preventDefault()
                    }
                  />

                  {this.props.DamagePartErrorlist[i] &&
                  this.props.DamagePartErrorlist[i]?.DamagequantityError ? (
                    part.Dquantity === 0 ||
                    part.Dquantity.toString() === '' ||
                    part.Dquantity.toString() === '0' ||
                    part.Dquantity.toString() === '.' ||
                    part.Dquantity.toString().includes('.') ||
                    part.Dquantity.toString() === 'e' ? (
                      <span className="rp-warranty-input-error-internal">
                        {i18n.t('partClaim.atleastqnty')}
                      </span>
                    ) : (
                      <span className="rp-warranty-input-error-internal">
                        {i18n.t('partClaim.quantityerror')} {part.Dtempquantity}{' '}
                      </span>
                    )
                  ) : part.Dquantity > 0 ? (
                    <span className="input-info">
                      {i18n.t('partClaim.Availableqnty')}
                      {part.Dtempquantity}
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="partprice"
                  >
                    {i18n.t('partClaim.unitprice')}:
                  </label>
                  <input
                    className={`form-control ${
                      part.Dunitprice !== '' ? 'form-control grey-color' : ''
                    }`}
                    placeholder="$ XX.XX"
                    name="part.price"
                    type="text"
                    min={0}
                    readOnly={true}
                    value={
                      part.DinvoiceNumber.toString() === ''
                        ? ''
                        : part.Dunitprice
                    }
                  />
                </div>

                <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="partprice"
                  >
                    {i18n.t('partClaim.partprice')}:
                  </label>
                  <input
                    className={`form-control ${
                      part.Dpriceshow !== ''
                        ? 'form-control grey-color'
                        : 'form-control'
                    }`}
                    placeholder="$ XX.XX"
                    name="part.price"
                    type="text"
                    min={0}
                    readOnly={true}
                    value={
                      part.DinvoiceNumber.toString() === ''
                        ? ''
                        : part.Dpriceshow
                    }
                  />
                </div>
                <div className="form-group  col-sm-12  col-md-6 col-lg-6 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="partprice"
                  >
                    {i18n.t('damageClaim.DescriptionofDamage')}
                    <span className="required">*</span>
                  </label>
                  <input
                    className={`form-control ${
                      this.props.DamagePartErrorlist[i]
                        ?.DescriptionOfDamageError
                        ? 'is-invalid'
                        : this.props.DamageErrormsgshow &&
                          part.DamageDescription === ''
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="part.description"
                    type="text"
                    min={0}
                    value={part.DamageDescription}
                    onChange={e => this.props.handleDamageDescription(e, i)}
                  />
                  <div>
                    {this.props.DamagePartErrorlist[i]
                      ?.DescriptionOfDamageError ? (
                      part.DamageDescription === '' ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.reqfield')}
                        </span>
                      ) : !/\S/.test(part.DamageDescription) ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.atleastchar')}
                        </span>
                      ) : part.DamageDescription.length > 250 ? (
                        !commentsRegEx.test(part.DamageDescription) ? (
                          <>
                            <span className="rp-warranty-input-error-internal">
                              {i18n.t('damageClaim.maxeigchar')}
                            </span>
                            <p className="rp-warranty-input-error-internal">
                              {i18n.t('partClaim.tracknumerror')}(
                              {i18n.t('partClaim.noSymbols')})
                            </p>
                          </>
                        ) : (
                          <span className="rp-warranty-input-error-internal">
                            ({i18n.t('damageClaim.maxeigchar')})
                          </span>
                        )
                      ) : (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </span>
                      )
                    ) : (
                      <span className="input-info">
                        <i>
                          {' '}
                          ({i18n.t('damageClaim.maxeigchar')}){''}
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </i>{' '}
                      </span>
                    )}
                  </div>
                </div>

                <div className={'picinfo-wrapper col-12'}>
                  <p>{i18n.t('damageClaim.pleasedonot')}</p>
                  <p>{i18n.t('damageClaim.ifudonot')}</p>
                  <p>{i18n.t('damageClaim.uponreceipt')}</p>
                </div>

                <div className={'pic-condition-wrapper'}>
                  <p>
                    {i18n.t('damageClaim.pictureofpart')}
                    <span className="required">*</span>
                  </p>
                  <p className={'minpic'} style={{ paddingBottom: '2px' }}>
                    {i18n.t('damageClaim.minimumpicinfo', {
                      min: env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 4 : 3,
                      max: 5
                    })}
                  </p>
                  <p className={'minpic'}>{i18n.t('damageClaim.maxsize')}</p>
                  <div className={'pic-condition-wrapper'}>
                    <p className={'p-10'}>
                      {i18n.t('damageClaim.umustinclude')}
                    </p>

                    <p className={'p-10'}>
                      1. {i18n.t('damageClaim.outsidepic')}
                    </p>

                    <p className={'p-10'}>
                      2. {i18n.t('damageClaim.damageonpart')}
                    </p>
                    <p className={'p-10'}>
                      3. {i18n.t('damageClaim.entirepart')}
                    </p>
                    {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                      <p className={'p-10'}>
                        4. {i18n.t('damageClaim.manulable')}
                      </p>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <ImageUpload
                  part={part}
                  handleDamagefileUpload={this.props.handleuploaddamagefiles}
                  i={i}
                  limit={env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 4 : 3}
                  max={5}
                  handleDeleteImage={this.props.handleDeleteImage}
                  handleRemoveImage={this.props.handleRemoveImage}
                  DErrormsgshow={this.props.DamageErrormsgshow}
                />
              </div>

              {this.props.DamagePartInfo.length > 1 && (
                <div className={`remove-button pd-delete`}>
                  <div className="rp-delete ">
                    <MuiThemeProvider theme={theme}>
                      <Tooltip
                        title={i18n.t('partClaim.photodelete')}
                        placement="bottom"
                      >
                        <button
                          className="primary-button d-flex"
                          onClick={e => {
                            e.preventDefault();
                            this.props.removePart(i);
                          }}
                        >
                          <DeleteIcon />
                        </button>
                      </Tooltip>
                    </MuiThemeProvider>
                  </div>
                </div>
              )}
            </div>
          ))}

          {/* <div className="mb add-button">
            <Button onClick={this.props.addPart} variant="contained">
              {i18n.t('partClaim.addPart')}
            </Button>
          </div> */}
        </div>
      </>
    );
  }
}

export default DamagePartInfo;

interface IDamagePartInfoProps {
  DamagePartInfo: any;
  DamagePartErrorlist: any;
  DamageErrormsgshow: boolean;
  handleDamagePartNumber: (event: any, i: any) => void;
  handleDamageinvoice: (event: any, i: any) => void;
  handleDamagequantity: (event: any, i: any) => void;
  handleDamageDescription: (event: any, i: any) => void;
  addPart: () => void;
  handleuploaddamagefiles: (event: any, i: any) => void;
  removePart: (i: any) => void;
  handleDeleteImage: (index: any, delimgindex: any, i: any, part: any) => void;
  handleRemoveImage: (event: any, i: any) => void;
  // failedimgdelete: () => string;
}
